module.exports = __webpack_public_path__ + "img/accessory_shirt_08.00ce70ae.svg";